import {
  ConsumptionStorageType,
  UsageGroupByType,
} from "@shared/types/localTypes/usage-explorer.ts";
import apiProxy from "@shared/utils/api-proxy.ts";

export type ConsumptionCsvGroupBy =
  | UsageGroupByType.TECHNICAL_SERVER_NAME
  | UsageGroupByType.PROJECT
  | UsageGroupByType.REPOSITORY;

export interface FetchConsumptionCsvRequest {
  nonce: string;
  start_date: string;
  end_date: string;
  subscription: number;
  storage_type: ConsumptionStorageType;
  group_by?: ConsumptionCsvGroupBy;
  partition_by: "month";
  partition_group_limit: number;
}

export interface FetchConsumptionCsvResponse {
  nonce: string;
  csv_rows: string[];
}

export default async ({ request }: { request: FetchConsumptionCsvRequest }) => {
  const response: FetchConsumptionCsvResponse | null = await apiProxy.post(
    "usage-explorer/consumption/csv",
    request,
  );

  if (!response) {
    throw new Error("Got no response from server");
  }
  return response;
};
